'use strict';

var AppDispatcher = require('../AppDispatcher'),
    ActionTypes = require('../constants/ActionTypes');

var SendInvitationFormActionCreators = {
  pushTag(tag) {
    AppDispatcher.handleViewAction({
      type: ActionTypes.INVITATION_FORM_PUSH_TAG,
      tag: tag
    });
  },

  clearSuggested() {
    AppDispatcher.handleViewAction({
      type: ActionTypes.INVITATION_FORM_CLEAR_SUGGESTED
    });
  }
};

module.exports = SendInvitationFormActionCreators;


/** WEBPACK FOOTER **
 ** ./actions/SendInvitationFormActionCreators.js
 **/